<style
  lang="less"
>
  // kkk 不设置scoped <= v-html 渲染出的标签，没有作用域信息
  .searchResult {
    em {
      color: red;
      font-style: normal;
      font-weight: normal;
    }
  }

</style>


<style
  lang="less"
  scoped
>
  @import "../../static/meta";

  .main-search {
    input {
      width: 410px;
      height: 42px;
      border: 1px solid #0077db;
      padding-left: 38px;
      background: url("@{v3-cdn}/search.png") no-repeat 10px center;
    }
    .searchBtn {
      width: 115px;
      height: 42px;
      color: #fff;
      text-align: center;
      background-color: #0077db;
      font-size: 16px;
      line-height: 42px;
      display: inline-block;
      vertical-align: bottom;
      margin-left: -6px;
    }
  }

  .person-search {
    position: relative;
    z-index: 100;
    input {
      width: 292px;
      height: 30px;
      background: url("@{v3-cdn}/sousuo.png") no-repeat 10px center #fff;
      padding-left: 30px;
      border: 1px solid #fff;
    }
    .searchBtn {
      width: 85px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #999999;
      font-size: 15px;
      display: inline-block;
      background-color: #f0f0f0;
      margin-left: -4px;
      vertical-align: bottom;
    }
  }
  .none{
    height:40px;
    line-height:40px;
    padding-left:12px;
  }
  .searchResult {
    background-color: #fff;
    border: 1px solid #dddddd;
    ul li {
      height: 40px;
      line-height: 40px;
      padding-left: 12px;
      color: #333;
      display: flex;
      justify-content:space-between;
      &:hover {
        background-color: #f5f5f5;
      }

      span {
        padding-right: 30px;
      }
    }

  }
</style>

<template>
  <div :class="searchClass">
    <input type="text"
           placeholder="输入您要搜索的内容"
           v-model="keyword"
           @blur="handleBlur"
           @focus="handleFocus"
    >
    <span class="searchBtn" @click="handleSearch">搜索</span>
    <div class="searchResult"
         v-if="active">
      <ul v-if="isResultEmpty" class="none">暂无搜索结果，尝试更换关键字</ul>
      <ul v-else>
        <router-link
          v-for="(item, index) in searchProduct"
          :to="{ name: 'product-detail', params: { serialId: item.serialId }}"
        >
          <li>
            <span v-html="item.name"></span>
            <span>{{ item.classificationName }}</span>
          </li>
        </router-link>
        <a href="#" @click="handleSearch">
          <li v-if="hasMore">......</li>
        </a>
      </ul>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  /**
   * 最多显示结果数
   * @type {number}
   */
  const MAX_RESULTS = 10

  export default {
    data () {
      return {
        keyword: '',
        active: false,
      }
    },
    computed: {
      ...mapGetters({
        getProducts: 'getProducts',
      }),
      /**
       *
       * @returns {*|Array}
       */
      searchProduct(){
        return this.$store.getters.searchProduct(this.keyword).splice(0, MAX_RESULTS) || []
      },
      isResultEmpty(){
        return this.keyword.length > 0 && this.searchProduct.length <= 0
      },
      hasMore(){
        return this.searchProduct.length >= MAX_RESULTS
      },
      searchClass(){
        switch (this.parentPage) {
          case 'person':
            return 'person-search'
          default:
            return 'main-search'
        }
      }
    },
    props: {
      parentPage: String,
    },
    methods: {
      handleBlur(){
//        console.log(`handleBlur`)
        setTimeout(() => {
          this.active = false
        }, 1000)
      },
      handleFocus(){
        this.active = true
      },
      handleSearch(){
        this.$router.push({name: 'search-result', query: {keyword: this.keyword}})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Search.vue?3b734a05